import React from 'react';
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import LocalAudioLevelIndicator from '../../../LocalAudioLevelIndicator/LocalAudioLevelIndicator';
import { LocalVideoTrack } from 'twilio-video';
import VideoTrack from '../../../VideoTrack/VideoTrack';
import useVideoContext from '../../../../hooks/useVideoContext/useVideoContext';

import { getIdentityInitials, removeIdentityMasking } from '../../../../utils';

const Container = styled('div')({
  position: 'relative',
  height: 0,
  overflow: 'hidden',
  paddingTop: `${(9 / 16) * 100}%`,
  background: 'black',
  borderRadius: '10px',
});

const InnerContainer = styled('div')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
});

const IdentityContainer = styled('div')({
  position: 'absolute',
  bottom: 0,
  zIndex: 1,
});

const Identity = styled('span')({
  background: 'rgba(0, 0, 0, 0.5)',
  color: 'white',
  padding: '0.18em 0.3em',
  margin: 0,
  display: 'flex',
  alignItems: 'center',
});

const AvatarContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#191b1d',
  position: 'absolute',
  color: 'white',
  fontSize: 'xxx-large',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  zIndex: 1,
  [theme.breakpoints.down('sm')]: {
    '& svg': {
      transform: 'scale(0.7)',
    },
  },
}));

export default function LocalVideoPreview({ identity }: { identity: string }) {
  const { localTracks } = useVideoContext();

  const videoTrack = localTracks.find(
    track => !track.name.includes('screen') && track.kind === 'video'
  ) as LocalVideoTrack;

  return (
    <Container>
      <InnerContainer>
        {videoTrack ? (
          <VideoTrack track={videoTrack} isLocal />
        ) : (
          <AvatarContainer>
            {getIdentityInitials(identity)}
          </AvatarContainer>
        )}
      </InnerContainer>

      <IdentityContainer>
        <Identity>
          <LocalAudioLevelIndicator />
          <Typography variant="body1" color="inherit" component="span">
            {removeIdentityMasking(identity)}
          </Typography>
        </Identity>
      </IdentityContainer>
    </Container>
  );
}
